import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { editMutations } from './types';
import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	OstatnipaId: null as number | null,
	PujcovnaId: null as number | null,
	OstatniNr: null as string | null,
	Text: null as string | null,
	SkladostOzn: null as number | null,
	SkladmistoostId: null as number | null,
	SkladmistoostIdText: null as string | null,
	SkladmistoostIdPopis: null as string | null,
	Priorita: null as number | null,
	StavPzn: null as number | null,
	StavText: null as string | null,
	Nc: null as number | null,
	Pc: null as number | null,
	PcPevna: null as number | null,
	Podminpa: null as string | null,
	PouzitelPzn: null as number | null,
	DphSzbOzn: null as number | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	Memo: null as string | null,
	Oznam: null as string | null,
	CmrozvrhId: null as number | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	ProvozovnaId: null as number | null,
	VyrazenDat: null as Date | null,
	NakladyJdn: null as number | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	OstatnipaVariaList: null as number[] | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		Cmrozvrh: [],
		DphSazba: [],
		OpaVaria: [],
		Pouzitel: [],
		Priorita: [],
		Provozovna: [],
		Pujcovna: [],
		Skladost: [],
		Stav: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {
		SazbyDph: null as any, // TODO: type.
	},
	extraActions: {},
	extraMutations: {
		[editMutations.SKLAD_MISTO_PREDMETU_SELECT_MAPPER](state, { data }) {
			state.edit.SkladmistoostId = data.id;
			state.edit.SkladmistoostIdText = data.value;
			state.edit.SkladmistoostIdPopis = data.text;
		},
		[editMutations.NAKLAD_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
